import React, { useEffect } from "react";
import { toast } from "sonner";
import { useProjectsStateContext } from "@/components/providers/ProjectsStateProvider/projects-state-provider";
import SectionBase from "@/components/ui/sections/section-base";
import SectionHeader from "@/components/ui/sections/section-header";
import { cls } from "@/lib/utils";
import type { ProjectName } from "../../types";
import ProjectsSectionItem from "./projects-section-item";
import ProjectsSectionItemSkeleton from "./projects-section-item-skeleton";

export const SECTION_ID = "projects-list";
const NUMBER_LOADING_SECTIONS = 6;

function ProjectsSection() {
  const { folderError, folders, images, isLoading } = useProjectsStateContext();

  useEffect(() => {
    if (!folderError) {
      return;
    }

    toast.error(
      `Oops! It seems that the projects failed to fetch. Please check your internet connection or try again! Thank you.`,
    );
  }, [folderError]);

  if (folderError) {
    return null;
  }

  return (
    <SectionBase id={SECTION_ID} background="bg-background">
      <SectionHeader
        subtitle="OUR PROJECTS"
        title="Quality Craftsmanship, Proven Results"
        description="Browse our portfolio of custom home builds and renovations across Claremore, Tulsa, and the surrounding areas. Each project reflects our commitment to personalized design and exceptional attention to detail."
      />

      <div className={cls`grid grid-cols-1 sm:grid-cols-2 gap-6 w-full mt-8`}>
        {isLoading
          ? Array.from({ length: NUMBER_LOADING_SECTIONS }).map((_, index) => (
              <ProjectsSectionItemSkeleton key={`skeleton-${index + 1}`} />
            ))
          : folders?.map(({ name }, index) => (
              <ProjectsSectionItem
                key={name}
                image={images ? images[name] : ""}
                projectName={name as ProjectName}
                index={index}
              />
            ))}
      </div>
    </SectionBase>
  );
}

export default ProjectsSection;
